import { CheckIcon, HourglassIcon } from "@primer/octicons-react";
import { Box, Timeline } from '@primer/react';
import { useEffect, useState } from 'react';
import { Card } from 'semantic-ui-react';
import { crmHocSinhApi } from '../../../api/crmHocSinhApi';
import { NotifyHelper } from '../../../helpers/toast';
import { IHocSinhQuaTrinhHoc } from '../../../models/response/crm-hocsinh/IHocSinhQuaTrinhHoc';
import { useCommonSelectedHook } from "../../../hooks/useCommonSelectedHook";

export interface IQuaTrinhHocProps {
    ts_hocsinh_id: number;
    canEdit?: boolean;
}

const QuaTrinhHocPage = (props: IQuaTrinhHocProps) => {
    const [quaTrinhHoc, setQuaTrinhHoc] = useState<IHocSinhQuaTrinhHoc[]>([]);
    const { nam_hoc } = useCommonSelectedHook();
    useEffect(() => {
        handleGetBHYTData();
    }, [props.ts_hocsinh_id]);

    const handleGetBHYTData = async () => {
        const res = await crmHocSinhApi.SelectQuaTrinhHoc(props.ts_hocsinh_id);
        if (res.is_success) {
            setQuaTrinhHoc(res.data);
        } else {
            NotifyHelper.Error(res.message ?? "Error");
        }
    };

    const colors = ['#9C27B0', '#673AB7', '#FF9800', '#607D8B'];

    return (
        <Box>
            <div className="card">
                <Timeline>
                    {quaTrinhHoc.map((item, idx) => (
                        <Timeline.Item key={idx}>
                            <Timeline.Badge sx={{ bg: colors[Math.floor(Math.random() * colors.length)], marginTop: '14px' }}>
                                {nam_hoc == item.nam_hoc ? (
                                    <HourglassIcon fill="#ffffff" />

                                ) : (
                                    <CheckIcon fill="#ffffff" />
                                )}
                            </Timeline.Badge>
                            <Timeline.Body>
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "baseline",
                                        // fontWeight: 600
                                    }}
                                >
                                    <Box sx={{ display: "flex" }}>
                                        <Box sx={{ fontWeight: 600, color: '#000' }}>{item.nam_hoc}</Box>
                                    </Box>
                                    <Box sx={{ display: "flex" }}>
                                        <Box sx={{ fontWeight: 600, color: '#000' }}>{item.truong_hoc}</Box>
                                    </Box>
                                    <Box sx={{ color: "fg.muted" }}>
                                        {item.khoi}, {item.he}, lớp {item.lop}
                                    </Box>
                                </Box>
                            </Timeline.Body>
                        </Timeline.Item>
                    ))}
                </Timeline>
            </div>
        </Box>
    );
};

export default QuaTrinhHocPage;
